module.exports = __webpack_public_path__ + "img/@work_img3.2d9da221.jpg";